export default "/images/vendor/@coreui/icons/svg/flag/cif-tl.svg?1153d9763941647a76fda3c89d257e5a";